import request from '@/utils/request'
// 协助上传检查单
export function uploadCheckFile(data) {
  return request({
    url: '/health-emr/checklist/uploadChecklistFile',
    method: 'post',
    data
  })
}
// 上传图片量表
export function uploadSurveyFile(data) {
  return request({
    url: '/health-doctor-assistant/survey/saveOrUpdatePictureSurvey',
    method: 'post',
    data
  })
}
